// Static source material supplied for the public example. Preserve original wording.
// Training metadata and internal provenance paths are deliberately excluded.
export const sampleSource = {
  "memoryBefore": {
    "source_kind": "input_history",
    "client_profile": "一、基本信息\n- 姓名：小李\n- 年龄：20\n- 性别：未知\n- 职业：大学生\n- 教育背景：大一\n- 婚姻状况：未知\n\n二、家庭与社会关系\n- 家庭情况：未知\n- 社会关系状态：未知\n\n三、身心状况\n- 既往病史：未知\n\n四、主诉与咨询目标\n- 主诉：与舍友/小组同学相处紧张、感觉自己像外人；近一个多月睡眠差（入睡晚至两点、噩梦、白天走神）。\n- 咨询主题：人际关系\n- 核心诉求：缓解在人际场景中的紧张与疏离感；将入睡时间逐步提前至约12点。\n\n五、成长经历\n- 1. 高中食堂被误会并遭到同学孤立、嘲笑和起外号，申请转学未果。\n- 2. 前舍友多次找各种理由让其搬走，最终搬出。\n- 3. 母亲不太听其讲细节，表达学校不顺时被回应“别矫情，专心学习”。\n\n六、核心信念\n- 1. 别人肯定不会喜欢一个外人；\n- 2. 觉得自己一无是处；\n- 3. 觉得自己很难融入这个集体。\n\n七、诱发事件\n  - 事件 1：\n    - 事件描述：刚开学被分到一个都是大三师姐的宿舍,她们关系已经很好.\n    - 条件性假设：如果我是新来的'外人',别人就不会喜欢我、不会接纳我\n    - 补偿性策略：预先假设对方不欢迎、减少接触以避免被拒绝\n    - 自动化想法：多我一个外人,再去融入那个小团体,多尴尬!不管我做什么都不会得到舍友的欢迎.\n    - 认知模式：Mind Reading\n    - 当前进展：待解决\n    - 分析：\n      - 第1个session: 详细回顾被分到大三师姐宿舍的小团体情境，来访者确认“如果我是新来的外人，别人就不会喜欢/接纳我”的条件假设与自动思维（“多我一个外人…不管我做什么都不会得到欢迎”），识别为Mind Reading；在具体宿舍片段中用ABC框架梳理A-念头B-情绪/行为C，并尝试寻找更温和的替代解释与练习一句“我”的陈述；布置睡前‘四列记录’以持续捕捉相关线索。\n      - 第2个session:围绕“我是外人、不被尊重”的读心偏差进行宿舍情境的ABC梳理与量化（委屈80→60、焦虑70→60、旧念头相信度85→65）；检验正反证据并形成更贴近事实的替代看法（“她们更可能是习惯晚睡，我是新来的，需要时间”相信度≈50）；演练轻量开口与备用方案（慢呼吸、安抚语、应付卡），并布置“思维与证据记录”及轻量开口尝试作为延续干预。\n      - 第3个session:围绕“晚睡与不安全/外人”片段进行了ABC与证据检验，要求列出支持与反证事实、生成不带评价的替代解释并做概率估计；将“她们可能只是习惯晚洗，我可以把需求说清楚”“一句‘等下’不等于不尊重，我可以再确认一下时间”写入应付卡；对旧念头（从80降至60）及委屈/慌张评分进行复评并降低；整合“三步卡”（两轮呼吸→看应付卡→轻量开口）以减少读心错误并促进开口。\n      - 第4个session: 针对“师姐宿舍像外人”的体验，来访者回顾了相关片段（聊天插不上话、对方少看自己、偶有借物与给WiFi等），进行证据检验以平衡“我是外人”的念头，并形成替代看法“她们关系好，我是新来的需要一点时间”（相信度约50）；同时将“习惯不一致≠不尊重，可以先确认、再协商”写为替代规则，预计结合本周沟通小实验继续验证。\n      - 第5个session:在新宿舍场景下复盘“先呼吸—看卡—再轻声开口”的清晰表达小实验，主动确认并协商洗澡时间；记录开口前后紧张评分（60→50）与旧/新规则相信度（旧约65→55，新约50），以行为实验削弱“我是外人不会被接纳”的读心推断，并收集接纳证据（借吹风机、提供WiFi密码、小组里有人点头打招呼）。\n      - 第6个session:围绕“刚开学被分到一个都是大三师姐的宿舍,她们关系已经很好.”的情境，转换并量化“我有值得被喜欢的地方/我不值得被喜欢”的新旧信念分，制定四级社交微行为清单（从打招呼、表达感谢/小请求到与两位同学各交流约30分钟），设定启动阈值与统一记录格式，现场做两段情境排练并使用“先两轮呼吸—看应付卡—再确认或转换话题”的退路脚本；会后安排参加班级活动、与宿舍同学交流，并通过“三条做得好的细节+一次自我肯定语+小奖励”巩固。\n      - 第7个session: 围绕“刚开学被分到一个都是大三师姐的宿舍,她们关系已经很好.”的情境，识别读心术倾向及相关自动化念头（“多我一个外人,再去融入那个小团体,多尴尬!不管我做什么都不会得到舍友的欢迎.”），通过开场寒暄与破冰、积极倾听与共情、表达请求与礼貌拒绝等人际技能微演练，选择班级分享会与纪录片兴趣社为具体场景，设定启动阈值（紧张≤55）、三项微行动与统一记录、退路脚本和当晚强化，并以“我有值得被喜欢的地方”作为替代性视角逐步落地。\n  \n  - 事件 2：\n    - 事件描述：前舍友老是找各种理由让其搬走,最终搬出.\n    - 条件性假设：如果出现一次被排斥,就说明我到哪里都会被排斥\n    - 补偿性策略：迅速撤离关系情境来降低被拒绝的痛苦\n    - 自动化想法：她们都不喜欢我,我被排挤了,以后换哪里也一样.\n    - 认知模式：Overgeneralization\n    - 当前进展：待解决\n    - 分析：\n      - 第1个session: 复盘被催搬的宿舍经历，来访者承认“她们都不喜欢我…换哪里也一样”的自动思维，明确其背后的条件假设（“如果出现一次被排斥，就说明我到哪里都会被排斥”）与认知偏差（Overgeneralization）；以共情与正常化连结到当下的人际紧张，并纳入‘四列记录’与后续重评的目标。\n      - 第2个session:识别“到哪里都一样”的以偏概全为结论性推断，要求以具体证据支持或修正；补充反向事实（借还小东西、给WiFi密码、偶尔回应“等下”、偶尔微笑）以削弱绝对化结论；结合记录作业与行为尝试持续检验并纠正过度泛化。\n      - 第4个session: 回顾搬宿舍经历并识别“到哪里都会被排斥”的过度概括，搜集反例（现宿舍借吹风机、给WiFi，小组同学打招呼等）以削弱推断；来访者对该信念的相信度由约70降至约55，计划在日常记录与沟通小实验中继续检验。\n      - 第5个session:将“前舍友多次让其搬走、最终搬出”纳入支持旧核心信念的证据清单，并与相反/中性片段并置，以降低过度概化的影响；在整体证据与再叙事下，旧核心信念评分由约70降至45–50。\n      - 第6个session:针对“前舍友老是找各种理由让其搬走,最终搬出.”，会谈中补充关键片段（对方借口与来访者当时嗓子发紧、少说话），明确当时的自动思维“到哪里都会被排斥”，对过度概括的认知倾向予以标记并选择从低难度社交行为起步，以逐步收集反例；同时约定暴露记录的评分与关键对话采集，配合呼吸与应付卡作为支持策略。\n  \n  - 事件 3：\n    - 事件描述：新宿舍两位舍友晚睡、说话、把排插线拉到床上且很晚才洗澡,导致其很晚才能洗漱入睡.\n    - 条件性假设：别人不按我的节奏=不被尊重/不安全\n    - 补偿性策略：反复关注舍友令自己不适的行为、内心抱怨又回避直接沟通\n    - 自动化想法：这样很不安全,我又摊上这样的舍友,真是太背了.\n    - 认知模式：Mental Filtering\n    - 当前进展：待解决\n    - 分析：\n      - 第1个session: 具体化舍友晚睡、聊天、拉排插等行为的时间与对入睡的影响，来访者连结“别人不按我的节奏=不被尊重/不安全”的条件假设与自动思维（“这样很不安全…太背了”），识别为Mental Filtering；在ABC中讨论支持/反驳证据与替代解释，并示范‘我’陈述的表达；将该情境纳入睡前‘四列记录’练习。\n      - 第2个session:以宿舍晚睡片段为目标进行完整ABC与证据检验，复评分显示情绪与旧念头相信度下降；制定并演练具体的轻量开口（先问洗澡时间→再表达关灯需求），配置三步小流程与备用方案作为行为实验，并将其纳入本周作业以促进沟通与安全感的重建。\n      - 第3个session:以“晚睡与不安全”具体场景做ABC与证据检验，明确事实与解释的区分并进行概率分配；通过两轮腹式呼吸练习降低当前生理紧张并纳入“三步卡”；设计“关灯前15分钟”流程（11:30手机勿扰并放桌面→尽量11:40前完成洗漱→回床做两轮呼吸；可尝试耳塞/眼罩），并设定可观察指标（入睡时间、夜醒次数、躺下前紧张评分）以巩固行为改变。\n      - 第4个session: 以“问洗澡时间—被回‘等下’”进行三轮角色扮演（回避版、简短I信息、清晰DESC），紧张评分约65→60→50，把握度约60；抽取规则“别人不按我的节奏=不被尊重/不安全”，做利弊分析并生成替代规则“习惯不一致≠不尊重，可先确认再协商”；制定小实验与指标（记录对方回应类型、当时紧张分、旧/新规则相信度），设置阈值（紧张≤50再开口）与备用流程（勿扰→两轮呼吸→耳塞/眼罩），纳入本周作业执行。\n      - 第5个session:在作息冲突情境下应用替代规则“先确认、再协商”，并记录紧张评分（开口前60、开口后50）及旧规则“别人不按我的节奏=不被尊重”的相信度（约65→55）；通过直接沟通减少抱怨与回避，识别并弱化过滤负面信息的倾向。\n      - 第6个session:围绕“新宿舍两位舍友晚睡、说话、把排插线拉到床上且很晚才洗澡,导致其很晚才能洗漱入睡.”的困扰，强化“表达更清楚了一点”的具体做法（先呼吸再询问洗澡时间），把表达感谢/小请求纳入Level 2目标并在课堂后情境进行排练，统一事前/事后紧张分与新旧信念评分的记录方式，并设定当晚自我强化与奖励机制。\n      - 第7个session: 针对“新宿舍两位舍友晚睡、说话、把排插线拉到床上且很晚才洗澡,导致其很晚才能洗漱入睡.”的情境，识别过滤式注意与安全担忧的自动化念头（“这样很不安全,我又摊上这样的舍友,真是太背了.”），进行了DESC界限维护与协商角色扮演两轮并优化为去个体化表述，提出更安心的做法与固定时间点的协商；配合紧张评分、统一记录、退路脚本与自我肯定语强化，尚需在实际场景中执行与检验，故为待解决。\n  \n  - 事件 4：\n    - 事件描述：高中食堂被误会并遭到同学孤立、嘲笑和起外号,转学无果.\n    - 条件性假设：一旦被污名化,我就会永远被贴标签\n    - 补偿性策略：在人际中保持防御、减少自我暴露\n    - 自动化想法：大家都会觉得我很恶心,之后在新的集体也会这样对我.\n    - 认知模式：Fortune Telling\n    - 当前进展：待解决\n    - 分析：\n      - 第1个session: 回顾高中食堂被误会后遭孤立、嘲笑与起外号（转学无果），来访者确认“一旦被污名化，就会一直被贴标签”的担心与自动思维（“大家都会觉得我很恶心…新的集体也会这样”），识别为Fortune Telling；通过正常化与安全风险评估（否认自/他伤计划）减轻贴标签恐惧，并将相关线索纳入后续‘四列记录’以支持认知重评。\n      - 第3个session:来访者自发联想到高中被误会与孤立经历，咨询师给予情感验证并指出该旧伤对当前触发的影响；将情绪安放后暂时将注意力回到当下的应对卡与行为步骤，未深入加工该创伤事件，暂定后续再探。\n      - 第5个session:按时间线重述食堂误会事件，提取自动念头（“他们觉得我很恶心”“我是不被喜欢的人”）及情绪/身体反应（鼻子酸、心里塌、嗓子紧）；用向下箭头识别核心信念“我不值得被喜欢/一无是处”，并进行证据检视与再叙事（误会扩散、跟风、老师处理不到位），更新可能性分布与信念评分（旧约70→50后至45；新约35提升至55–60）。",
    "sessions": [
      {
        "session_number": 1,
        "title": "建立关系，识别人际与睡眠困扰",
        "display_summary": "识别“我是外人”的自动想法及回避模式；约定四列记录，尝试表达个人需要。",
        "display_summary_origin": "editorial_summary_of_input_memory",
        "source_kind": "input_history",
        "stage": "问题概念化与目标设定",
        "summary": "本次为首次会谈，咨询师以温和的寒暄与体感关怀降低来访者紧张（其自述“嗓子紧、手有点冷、不太敢看你”），随后清晰说明会谈结构、保密原则与风险例外并获得同意。确认称呼为“小李”后，来访者用自己的话提出主诉：与舍友、小组同学相处不适、感觉像外人，近一个月失眠（约两点入睡、噩梦多）、上课走神，希望减少紧张、提前入睡并不再总是感觉融不进去。会谈系统收集了基本信息（年龄、年级、住宿、社交、安全风险等），并反馈量表结果为轻度焦虑、人际敏感及抑郁偏高；来访者表达“有点害怕、担心自己是不是有问题”，咨询师给予正常化与风险筛查，来访者否认自/他伤意念。围绕宿舍情境进行了初步ABC：事件为室友晚睡聊天、拖延洗漱，自动化思维包括“我是外人，她们不会喜欢我、这样不安全”，情绪为强烈委屈与不轻的焦虑，行为为“躺着假装睡着等待”。在证据检验中，来访者能提出温和替代解释（可能只是习惯晚睡），并在咨询师引导下尝试“I信息”表达的句式草案，但仍担心被忽视。会谈也梳理了触发旧信念的早期经历：高中食堂被误会后遭孤立、被贴标签与“一无是处”的自我评价。最后双方共同明确短期目标（紧张降至中等偏轻，入睡提前至十二点）与合作节奏，并布置“四列关键字记录”作业（设睡前提醒），若合适则尝试一句“I陈述”，约定下次会谈。",
        "state_analysis": "- 情绪状态：入室时明显紧张与躯体化（“嗓子紧、手有点冷、不太敢一直看你”）；在宿舍事件中“委屈挺强烈，焦虑也不轻”；听到量表结果后“有点害怕，担心自己是不是有问题”；白天呈疲惫、注意力不集中。整体为焦虑、委屈与害怕并存，在咨询师正常化后稍有缓解（来访者反馈“没那么害怕了”）。\n- 认知模式：显著的读心术与标签化：如“我是外人，她们不会喜欢我”“不尊重我”；以偏概全：“她们都不喜欢我，换哪里也一样”；心理过滤与灾难化：“这样很不安全，我又摊上这样的舍友，真是太背了”；预言式错误：“大家都会觉得我很恶心，在新的集体也会这样对我”；核心自评倾向：“那段时间特别自卑，觉得自己一无是处”。\n- 行为模式：回避与被动等待：“我就躺着假装睡着，等她们”；社交回避与减少接触：“能躲就躲”“基本就在宿舍和教室自己待着”；合作度良好：愿意参与ABC与证据检验，接受“四列关键字记录”与设置提醒，谨慎愿意尝试“I陈述”但仍有顾虑（“怕她们不理我”）。\n- 治疗关系：信任与合作度较好：来访者愿意分享脆弱体验与过去事件，积极回应结构和作业；在结尾表示“把念头和感觉分开来看对我有帮助…下周这个时间可以”。咨询师的共情与正常化降低其对量表与自我状态的恐惧，联盟初步稳固。\n- 未解决议题/张力：1) 对舍友“不尊重/不安全”的联结未充分检验，仍有被忽视的担忧（“怕她们不理我”）；2) 高中被污名化事件关联的核心信念（“一无是处”“外人不会被喜欢”）仅初步命名，未进行系统证据重估与替代信念构建；3) 睡眠维度的具体行为策略（睡眠卫生/放松）尚未启动；4) 作业执行的障碍意识存在（“怕忘记或者写不好”），需下次追踪完成度与困难解决。"
      },
      {
        "session_number": 2,
        "title": "区分事实与解释，尝试表达需求",
        "display_summary": "回顾3次记录，检验“她们不尊重我”的想法；准备轻量开口及备用安抚方案。",
        "display_summary_origin": "editorial_summary_of_input_memory",
        "source_kind": "input_history",
        "stage": "核心认知与行为干预",
        "summary": "本次为第2次会谈，咨询师先以体感关怀与量化评分协助来访者定位当下状态（紧张60–65、委屈70），并预告本次流程。随后检查“四列关键字”作业，来访者完成3次并选取宿舍情境为焦点：“晚睡—外人—委屈强烈—躺着装睡”。在具体复盘中，提炼ABC：A为舍友十一点后仍聊天、十二点半才洗澡；B为“我是外人、她们不尊重我”；C为委屈、焦虑与回避等待，并量化当时委屈80、焦虑70、旧念头相信度85。进入证据检验后，来访者既能给出支持证据（少看她、少回应、曾被要求搬宿舍），也在引导下找到反证据（借还物品、给WiFi、偶尔回应与微笑），据此生成替代看法“她们可能习惯晚睡，我是新来的需要时间”，其相信度50；旧念头降至65，委屈降至60、焦虑至60。会谈进一步进行轻量沟通演练：先询问洗澡时间，再用I信息表达关灯需求，并共同拟定备用自我安抚方案（慢呼吸与安抚语）。中途来访者自发链接到早期被母亲指责“矫情”的被忽视感，咨询师共情并将其暂置，回到当下技能练习。结尾布置升级版“思维与证据记录”、轻量开口尝试与三步小流程支持，确认设置睡前提醒与应付卡的使用，来访者表示可行。",
        "state_analysis": "- 情绪状态：入室时自述不安心与委屈（紧张60–65、委屈70）；在宿舍事件中委屈80、焦虑70；经证据检验与替代思维后委屈降至60、焦虑降至60；对即将开口的预期紧张为75。谈及母亲“不听我说话、说我矫情”时出现鼻酸，显示被忽视相关的情绪线索。\n- 认知模式：核心自动化思维：“我是外人、她们不尊重我”；伴随读心术与过度推断（少回应即“不尊重我”）、以偏概全（“到哪里都一样”）。通过正反证据整合，形成替代看法“她们可能习惯晚睡，我是新来的需要时间”，旧念头相信度由85降至65，替代看法相信度约50，显示认知重评初步有效但仍需巩固。\n- 行为模式：回避：在宿舍“躺着装睡、等待”；小组讨论“等结束赶紧走”。作业执行：本周完成三次记录，表述清晰。会谈中积极参与演练，愿意尝试轻量开口（询问时间与表达关灯需求），并设定备用自我安抚流程与睡前提醒，合作度良好。\n- 治疗关系：联盟稳固。来访者愿意量化情绪与念头、开放分享作业与家庭触发点；咨询师以共情与结构化引导支持其安全感与自我效能（“把感觉安放好、回到练习”），来访者认可并承诺执行。\n- 未解决议题/张力：1) 旧念头“外人/不被尊重”仍有较高相信度（65），需在真实互动中继续检验与巩固。2) 预期开口紧张75，可能成为行为尝试的障碍（嗓子绷）。3) 以偏概全的推断（“到哪里都一样”）虽被识别但未充分重估。4) 早期被忽视体验（母亲说“矫情”）触发的情感尚未加工，需在后续连接中间/核心信念。5) 睡眠卫生与具体环境调整未详细制定，后续可补充。"
      },
      {
        "session_number": 3,
        "title": "建立三步应对卡与睡前流程",
        "display_summary": "形成“呼吸→看卡→开口”流程，安排睡前准备；旧念头和失眠仍需继续观察。",
        "display_summary_origin": "editorial_summary_of_input_memory",
        "source_kind": "input_history",
        "stage": "核心认知与行为干预",
        "summary": "本次为第3次会谈。咨询师以体感关怀与量化开场，来访者报告“这周还有两天到两点才睡…上课注意力比上次稍微好一点”，此刻紧张55、委屈50，并同意当次流程安排。作业回顾显示完成两条完整“思维与证据记录”与一条半，且尝试一次轻量开口（先问洗澡时间），但在对方回应“等下”后未继续表达。双方选取该片段做ABC：来访者当时自动思维为“她们不尊重我、我是外人”，相信度80，委屈70、慌张70。证据检验中来访者能列出支持证据（“等下”后拖到12:30洗澡、少看她、她说话无人接）与反证据（借吹风机、给WiFi、偶有微笑点头），并生成多重解释（习惯晚洗/当时在忙/未意识到）。在概率估计后，旧念头相信度降至60，委屈55、慌张50。咨询师引导其以自语形成替代陈述：“她们可能只是习惯晚洗，我可以把需求说清楚”“一句‘等下’不等于不尊重，我可以再确认一下时间”，写入应付卡。谈及“被不理”的瞬间来访者自发联想到高中被误会与孤立，鼻酸上涌，咨询师予以共情并把情绪先安放，回到当下技能。随后现场练习两轮腹式呼吸，紧张由50降至45、再降至40，并将其整合为“三步卡”（两轮呼吸→看应付卡→轻量开口）。在睡眠方面，共同制定“关灯前15分钟”流程：11:30手机勿扰并放桌面、尽量11:40前完成洗漱、回床两轮呼吸，若合适尝试耳塞。确立基线与目标：当前入睡1:40–2:00、夜醒0–1次、临睡前紧张65，目标为入睡约12:20、夜醒0–1次、紧张≤50。结尾明确本周作业：每日至少1条思维与证据记录并标注放松/睡前技巧及呼吸前后评分；睡前坚持两轮腹式呼吸；完成一次轻量开口或中性问候，按“三步卡”执行；设11:30提醒与被打断时的备用流程。来访者表示“可行…知道先做什么，再做什么”，并总结带走的要点。",
        "state_analysis": "- 情绪状态：入室主观紧张55、委屈50；在复盘宿舍片段时委屈70、慌张70；经证据检验降至委屈55、慌张50；腹式呼吸两轮后当下紧张50→45→40。谈及高中被误会与孤立时“鼻子有点酸”，提示与被忽视/被排斥相关的情绪线浮现。\n- 认知模式：主要自动化思维：“她们不尊重我、我是外人”；认知偏差包括读心术、选择性注意与结论跳跃。通过证据检验与发散解释，能进行概率估计（不尊重/外人40%、习惯晚洗35%、忙/未意识到25%），并形成替代陈述：“一句‘等下’不等于不尊重…我可以再确认时间”“她们可能只是习惯晚洗，我可以把需求说清楚”。旧念头相信度从80降至60，但仍偏高，需现实情境进一步检验巩固。\n- 行为模式：行为上表现为回避（对方回“等下”后未进一步表达），但已进行一次轻量开口并完成2条完整记录、1条半记录；当场学习并练习两轮腹式呼吸，愿意将其纳入“三步卡”；与咨询师共同制定“关灯前15分钟”流程并设定可观察指标，表现出良好合作与执行意愿。\n- 治疗关系：合作与信任度高。多处回应“可以/可行”，主动总结收获与应付卡语句；咨询师的结构与共情（对高中事件“很扎心”的回应）被良好接收，双方能在情绪安置后回到技能训练，联盟稳固。\n- 未解决议题/张力：1) 旧念头“外人/不被尊重”仍有较高相信度（60），需在真实互动中继续证据检验与替代思维巩固；2) 现实情境中未完成“确认时间或提出需求”的关键一步，回避倾向仍在；3) 临睡前紧张基线65与入睡时间1:40–2:00，目标—现实差距仍大，睡前流程的坚持与微障碍需追踪；4) 高中被误会与孤立相关的情绪触发已浮现但未深入加工，后续需与中间/核心信念连接；5) 对舍友习惯的替代解释需通过小型行为实验与数据记录进一步验证。"
      },
      {
        "session_number": 4,
        "title": "练习清晰表达，检验旧规则",
        "display_summary": "通过角色扮演练习清晰表达，形成“习惯不一致不等于不尊重”的替代规则。",
        "display_summary_origin": "editorial_summary_of_input_memory",
        "source_kind": "input_history",
        "stage": "核心认知与行为干预",
        "summary": "本次为第4次会谈，咨询师以量化开场并预告流程，来访者报告“这周还是有两天到两点才睡…现在紧张55，委屈50”，同意当次安排。作业回顾显示完成两条完整记录、呼吸练习三晚，并提出两段不适互动。双方以“问洗澡时间—被回‘等下’”为素材进行三轮角色扮演：第一轮回避式回应后紧张65、慌张60；第二轮简短I信息紧张约60；第三轮用DESC更清晰表达，紧张降至50、情境把握度约60，来访者自述“鼻子有点酸，但没那么堵”。随后用向下箭头抽取并检视中间规则“别人不按我的节奏=不被尊重/不安全”，完成利弊分析并生成替代规则“习惯不一致≠不尊重，可以先确认、再协商”，旧规则相信度70→60，新规则约45。咨询师补齐“师姐宿舍像外人”的证据视角，来访者在支持与反证据间形成替代看法“我是新来的需要一点时间”，相信度约50；对“到处都会被排斥”的推断，也在例外事实下将相信度70→55。会谈共同拟定清晰表达的小型行为实验（含台词、执行阈值≤50、备用方案），并明确本周作业：每日思维与证据记录（含呼吸前后评分）、周三一次清晰表达实验与数据记录、坚持“关灯前15分钟+两轮腹式呼吸”流程。结尾来访者选定应付卡语句“习惯不一致不等于不尊重，可以先确认再协商”，并同意准备高中关键片段供下次探索核心信念。",
        "state_analysis": "- 情绪状态：入室自评紧张55、委屈50；在角色扮演初轮紧张65、慌张60，第三轮降至紧张约50、把握度60；谈及“被不重视/到处被排斥→不值得”出现鼻酸与难受；整体呈中度紧张与委屈，在清晰表达练习与替代规则形成后有所缓解。\n- 认知模式：关键自动化思维：“她们不尊重我、我是外人”；中间规则：“别人不按我的节奏=不被尊重/不安全”；推断与核心贴近念头：“到处都会被排斥→不值得被喜欢/一无是处”。认知偏差以读心术、以偏概全与结论跳跃为主。通过证据整合与替代规则，旧念头/旧规则相信度分别降至65–60，新替代看法/规则相信度约45–50，显示初步重评但仍需现实巩固。\n- 行为模式：回避倾向：被回“等下”后“不敢接着说”。技能练习：完成两条完整记录、三晚呼吸；在会谈中进行三轮角色扮演与清晰表达脚本拟定，并同意周三做一次微型实验；执行意愿良好且能设定阈值与备用方案。\n- 治疗关系：合作与信任度高。来访者多次回应“可以…行”，主动提出障碍与可行性（“七八成”），认可应付卡语句并愿意准备成长经历；咨询师的共情与结构化引导被良好接收，联盟稳固。\n- 未解决议题/张力：1) 旧规则/旧念头仍有较高相信度（60–65），现实互动中的巩固尚未完成；2) 当舍友聊天热烈时仍预期犹豫，行为尝试可能受阻；3) 睡眠仍有两晚至2点入睡，“关灯前15分钟”流程的坚持与效果需追踪；4) 高中被误会事件仅做下次准备，核心信念层面的情绪与意义未深入加工；5) “一无是处/不值得被喜欢”的核心断言刚浮现，需在后续向下箭头与证据重估中系统处理。"
      },
      {
        "session_number": 5,
        "title": "探索自我价值，收集优势证据",
        "display_summary": "探索“我不值得被喜欢”的旧信念，布置优点与证据清单、自我肯定和应付卡。",
        "display_summary_origin": "editorial_summary_of_input_memory",
        "source_kind": "input_history",
        "stage": "核心认知与行为干预",
        "summary": "本次第5次会谈以量化开场，来访者自评紧张55、委屈40，咨询师预告将聚焦成长经历与核心信念。先回顾“先呼吸—看卡—再轻声开口”的微型行为实验：来访者描述周三开口询问洗澡时间，开口前紧张60、后降至50，旧规则相信度65→55，新规则约50，认为最有帮助的是先呼吸与把话说清楚，卡点是听到“等下”嗓子会绷住。随后进入成长脉络与向下箭头：回溯高中食堂误会扩散的片段，自动化思维为“他们觉得我很恶心”“我是不被喜欢的人”，当时鼻酸、嗓子紧；进一步下探旧核心信念“我不值得被喜欢/一无是处”，初始相信度70。证据重估与连续谱后，综合反例（宿舍借物与WiFi、小组点头、小学当班干部有朋友），来访者将旧解释概率定为55%，替代解释“需要时间”30%、“在忙/没注意到”15%，并用再叙事将事件理解为误会扩散。旧核心信念降至50，再结合母亲“不听我说”片段进行证据与可能性重估，形成更平衡的核心陈述“我的价值不由他人当下回应决定…”，旧核心进一步降至45、新核心“我有值得被喜欢的地方”升至60，来访者反馈“胸口没有刚才那么闷了”。结尾布置巩固作业：三天分步完成“10个优点+证据”（3→6→10）、每日一次自我肯定语并练习前后打分、制作核心信念应付卡与手机提醒，以支持新信念的内化与维持。",
        "state_analysis": "- 情绪状态：开场主观紧张55、委屈40；行为实验后紧张从60降至50；在回忆高中与母亲片段时出现鼻酸与嗓子紧，后经再叙事与新陈述练习反馈“胸口没有刚才那么闷了”，整体呈中度紧张伴脆弱情绪，后段有所缓解。\n- 认知模式：核心自动化思维与信念：高中事件触发“他们觉得我很恶心”“我是不被喜欢的人”；下探至旧核心“我不值得被喜欢/一无是处”（初始70→45–50）。伴随认知偏差包括标签化、以偏概全与读心术。通过证据重估与连续谱，形成替代信念“我有值得被喜欢的地方”（35→55–60）与平衡陈述“我的价值不由他人当下的回应决定…”。\n- 行为模式：执行一次清晰表达的微型行为实验，按“三步卡”先呼吸再开口，能量化前后紧张与旧/新规则相信度；在会谈中积极参与证据列举、概率估计与第一人称新陈述练习；对作业的完成度自评70%，愿意拆分步骤与设置提醒，合作度高。\n- 治疗关系：联盟稳固。来访者配合量化与深入追溯，能开放脆弱体验并参与重评与自我陈述；咨询师以结构化引导与共情支持其安全感与效能，来访者多次回应“可以…更清楚怎么做了”。\n- 未解决议题/张力：1) 听到他人回应“等下”时仍出现“嗓子会绷住”的瞬时生理紧张，可能影响后续表达的持续性；2) 旧核心信念仍在中等强度（约45–50），需通过优势证据与日常练习进一步巩固；3) 母亲相关情境仅初步重估，未系统探查需求表达与界限设定的行为路径；4) 优点清单书写存在“别扭/易忘”的障碍，需通过分步与提醒维持执行。"
      },
      {
        "session_number": 6,
        "title": "把新信念落实为社交行动",
        "display_summary": "已记录6条优点、5次自我肯定、4次应付卡使用；计划分级社交尝试及简短记录。",
        "display_summary_origin": "editorial_summary_of_input_memory",
        "source_kind": "input_history",
        "stage": "核心认知与行为干预",
        "summary": "本次为第6次会谈，咨询师以量化开场，来访者自评紧张50、委屈35；睡眠较上周略有改善（两晚约1:40入睡，1晚12:50），上课走神减少。随后回顾“优点清单+自我肯定”练习：已写至6条、睡前自我肯定语5次、应付卡使用4次，练习前后“新/旧核心信念”评分分别上调与下调。来访者挑选“表达更清楚了一点”最能提升价值感，也识别“夸自己别扭、想不起例子”为难点，分步与手机提醒被验证有效。为贴近真实阻碍，来访者简述前宿舍被要求搬走时“嗓子紧、几天后就搬”并出现“到哪里都会被排斥”的旧推断；咨询师予以共情后，聚焦行动化：共创四级社交微行为清单（打招呼→感谢或小请求→10–15分钟闲聊→与两位同学各30分钟交流），逐级设定预期紧张值与新/旧信念目标分，并明确启动阈值（紧张≤55尝试）。在两段情境中完成排练并前后评分，配套“退路脚本”（两轮呼吸→看应付卡→再确认/转话题）与统一记录格式。结尾制定一周行动与强化计划：参加一次班级分享会，与两位同学各交流约30分钟；事前10分钟提醒执行“呼吸+看卡”，当晚记录“三条做得好的细节+自我肯定语”，并以奶茶或纪录片奖励，若当场紧张或易忘则用手机备忘录先记关键字、晚些补全。",
        "state_analysis": "- 情绪状态：会谈初紧张50、委屈35；排练前基线紧张约51–52，排练后降至48与47；自我肯定后新信念提升（约48→63），旧信念降低（约53→46）。整体呈中度紧张、低中度委屈，随练习与结构化计划而缓解。\n- 认知模式：旧核心信念：“我不值得被喜欢”；相关自动化推断：“到哪里都会被排斥”。新核心信念：“我有值得被喜欢的地方”。主要认知偏差仍包括以偏概全与读心式推断。通过优势证据与自我肯定，旧信念在练习后下调，新信念上调，显示重评在巩固中。\n- 行为模式：本周完成优点清单6条、自我肯定5次、应付卡4次；同意并共创四级社交暴露清单，完成两轮情境排练与前后评分；设定启动阈值（紧张≤55尝试）、统一记录格式与退路脚本。识别主要障碍为“当场紧张与忘记记录”，并配置提醒与关键字先记。\n- 治疗关系：合作度与信任度高。多次回应“可以”“这样我心里有数”，能开放描述困难（别扭、嗓子紧）并接受结构化计划、奖励与备忘策略，显示对治疗框架与目标的认同。\n- 未解决议题/张力：1) 更高难度情境（Level 3–4）仅排练未实作，现实验证数据待收集；2) 旧核心仍有中等相信度区间（约39–46），需通过暴露与优势证据进一步松动；3) 前宿舍“被要求搬走”触发的以偏概全仅被触及，未系统重估；4) 睡眠虽有一晚提前至12:50，但整体仍偏晚（两晚约1:40），相关睡前流程与行为化维持需继续巩固。"
      },
      {
        "session_number": 7,
        "title": "回顾现实尝试，练习对话续接",
        "display_summary": "记录分享会及两次交流，练习开场、倾听、请求和拒绝；被打断后续接及睡眠仍待巩固。",
        "display_summary_origin": "editorial_summary_of_input_memory",
        "source_kind": "input_history",
        "stage": "核心认知与行为干预",
        "summary": "本次为第7次会谈，咨询师以量化开场与流程预告稳定节奏。来访者自评紧张48、委屈30，睡眠两晚约1:40、一晚约12:50，上课专注略好。先回顾一周行动与记录：周四参加班级分享会，签到主动打招呼；周五在图书馆与同学聊约25分钟，事前紧张52→事后48，“新核心信念”60→66、“旧核心”44→40；周日在宿舍与同学聊约15分钟被快递打断，事前紧张55→事后51，新61→63、旧43→41，来访者自述开口时“嗓子有点绷住、怕冷场”，被打断后“有点尴尬”。咨询师示范桥接句并进入人际技能微训练：开场寒暄两轮后紧张50→46→44，新核心60→63、旧42→38；积极倾听中加入“反映+肯定+开放问题”，紧张约45；表达请求后紧张45，礼貌拒绝略别扭紧张47；DESC就“排插/晚洗”练两轮并优化为去个体化措辞，紧张52→50，新核心64→65、旧38→37。随后共同制定关系网络拓展：选择“班级分享会（每周）”与“纪录片兴趣社（每月两次）”，沿用启动阈值紧张≤55。明确三项微行动（签到打招呼、结束感谢并小聊5–10分钟、提出小请求/建议）与统一记录字段、退路脚本（两轮呼吸→看卡→桥接/转话题）及当晚强化（“三条做得好的细节+自我肯定语+小奖励”）。来访者评估完成可能性约七成，主要障碍为当场紧张与忘记记录，拟用“事前10分钟提醒+备忘录关键字先记”解决。会谈以肯定其将“我有值得被喜欢的地方”落到具体行动作结。",
        "state_analysis": "- 情绪状态：入室紧张中等（48）、委屈偏轻（30）；两次现实交流后事后紧张分别降至48与51；演练中紧张由50降至44，DESC优化后至50。被打断和礼貌拒绝环节出现“嗓子绷住、别扭”的紧张小幅上升（至47）。整体呈中度紧张、低中度委屈，随练习与结构化计划逐步缓解。\n- 认知模式：核心信念轨迹：新“我有值得被喜欢的地方”在交流与演练中上调（如60→66/63/65），旧“我不值得被喜欢”下调（如44→40/38/37）。情境性自动思维包括“怕冷场/被打断就尴尬”，体现对负性结果的过度预期与结论跳跃。通过桥接语与去个体化DESC，开始形成更平衡的解释与自我效能脚本。\n- 行为模式：本周完成一次班级活动与两次交流；多数场合能执行“两轮呼吸+看卡”；被打断时倾向终止对话，尚未自发桥接。会谈中积极参与四项技能演练、评分与脚本优化；愿意执行三项微行动与统一记录，识别并预防“忘记记录”的障碍（事前提醒、关键字先记）。\n- 治疗关系：合作与信任度高。来访者主动提供数据并参与多轮角色扮演，频繁回应“可以…我就按这个来”，显示对结构与节奏的认同。咨询师以肯定与具体化微步骤提升可控感，联盟稳固。\n- 未解决议题/张力：1) 被打断后的续接仍欠熟练，易出现尴尬与终止；2) 礼貌拒绝环节“有点别扭”，需在现实情境中进一步练习与强化；3) 启动阈值虽明确，高难度（持续小聊/提出建议）尚缺真实数据；4) 睡眠虽有一晚提前至12:50，整体仍偏晚（两晚约1:40），需持续巩固睡前流程；5) 记录依从性存在忘记与当场紧张的风险，需依赖提醒与关键字先记策略。"
      }
    ],
    "previous_homework": "- 参加一次班级分享会（启动阈值≤55），按三项微行动执行并记录\n- 至少完成两次“5–10分钟小聊”或“一次小请求/建议”\n- 至少一次兴趣社活动或报名+一次线上互动\n- 每次按统一格式记录，并当晚做自我奖励\n- 每日一次自我肯定语，记录练习前后分",
    "current_goals": "- 开场与关系维护：以简短自然的寒暄与体感关怀，快速评分当下心境与紧张/委屈（0–100），了解自上次会谈以来的生活事件与睡眠/人际进展，回顾家庭作业执行情况，并共同确认今日议程为“整合复盘与复发预防”以降低进入会谈的生理唤醒。\n- 总体回顾（回顾性连接）：系统回顾整个咨询历程中的关键变化，基于历史会谈记录对比初始与当前的情绪、睡眠、交往与沟通技能、核心/中间信念的相信度轨迹及现实行为证据；将进展归功于来访者的努力，提炼可迁移的收获。\n- 测评复测与对照（首次探索性）：进行本次量表复测并收集最新评分，与初评数据做对照；讨论主观改善与客观指标的一致与差异，明确需要继续巩固的领域，并将结果记录为后续自我监测的基线。\n- 工具箱整合（回顾性整合）：在既有信息基础上列出并归纳已掌握的技能（如ABC与证据检验、认知重评、腹式呼吸放松、DESC清晰表达、分级暴露、核心信念自我肯定与应付卡等），为每项明确适用情境、关键步骤与提醒策略，制作一页“个人工具箱清单”。\n- 复发预防计划（回顾+首次探索）：回顾已知的高风险情境与触发主题（如被打断后的尴尬、礼貌拒绝的别扭、睡前高唤醒与外人感等），首次识别个人的早期预警信号（情绪/生理/行为指标与评分阈值），并为每类情境共创具体应对脚本（两轮呼吸→看应付卡→桥接/确认→DESC协商或退出），明确自我治疗会谈微流程与支持资源清单（同学/老师/校心理中心），设定启动阈值与记录字段。\n- 维持与终结安排（首次探索）：设定后续自助练习的频率与里程碑检查点（如每周一次自我治疗会谈、每月一次复盘与量化），约定出现波动时的自助步骤与再求助路径，逐步拉开咨询间隔并预告3–6个月后的巩固性会谈；邀请并处理对结束的自动思维与分离情绪，完成正向告别与会谈总结。"
  },
  "conversation": {
    "session_number": 8,
    "therapy": "CBT",
    "source_kind": "generated_rollout",
    "assistant_turns": 24,
    "source_status": "completed",
    "natural_end_marker_present": false,
    "end_note": "保存片段在咨询师提问后结束；completed不表示自然结束。",
    "messages": [
      {
        "id": "m01",
        "role": "assistant",
        "turn": 1,
        "text": "小李，欢迎回来。此刻你的紧张只有0–100处在多少？委屈呢？另外，想不想先回看上次我们约定的三项微行动里，你做出改变最明显的一处？"
      },
      {
        "id": "m02",
        "role": "user",
        "turn": 1,
        "text": "紧张的话大概是在四十多吧，委屈反而没怎么有，感觉心里稍微松快了一些。我想想啊，上周那个分享会里，我签到时主动跟旁边同学打了个招呼，说完“你好”后居然没有像以前那样直接躲回去，当时虽然嗓子还是有点紧，但好像真的没那么害怕冷场了。"
      },
      {
        "id": "m03",
        "role": "assistant",
        "turn": 2,
        "text": "你已经把“我有值得被喜欢的地方”落到了一个具体场景里，这很实在。回到那一刻，你最先执行、最让你稳下来的是哪一个步骤？"
      },
      {
        "id": "m04",
        "role": "user",
        "turn": 2,
        "text": "其实那一刻最稳的，应该是我先做的那两轮深呼吸吧，当时嗓子挺紧的，感觉快要说不出来了，我低头默数了几秒，心里告诉自己“只是节奏不一样，不是针对我”。点开那个应付卡，看着“习惯不一致不等于不尊重”那行字，好像没那么慌张了，才敢把脚往前挪一步，对着师姐说了句“不好意思，刚才在整理笔记”。"
      },
      {
        "id": "m05",
        "role": "assistant",
        "turn": 3,
        "text": "如果把刚才的做法浓缩成一个简短的组合，你会怎么命名它？"
      },
      {
        "id": "m06",
        "role": "user",
        "turn": 3,
        "text": "其实……我觉得就叫“先深呼吸，再看我的那张小卡片，然后才敢开口”挺合适的吧？\n\n刚才练那几轮的时候，我脑子里确实就闪过这个念头，好像只要按这个顺序来，就不会像以前那样一下子慌住。"
      },
      {
        "id": "m07",
        "role": "assistant",
        "turn": 4,
        "text": "如果用“情境—身体信号—情绪变化”的线索来看，最近一次紧张变化最强，发生在哪一个具体片段？那时你最明显的身体提醒和情绪波动是什么？"
      },
      {
        "id": "m08",
        "role": "user",
        "turn": 4,
        "text": "我觉得是上次在图书馆跟那个同学聊了二十多分钟的时候，那天准备得挺充分的，可刚开口嗓子就开始发紧，心跳特别快，手心里全是汗。那时候脑子里突然就冒出一个念头，觉得万一我说错话她们肯定又要躲着我，那种委屈感一下子就没忍住涌上来，眼泪差点掉下来。"
      },
      {
        "id": "m09",
        "role": "assistant",
        "turn": 5,
        "text": "如果回看那一刻你是否用过“减负三步”中的哪怕一小部分（比如两轮呼吸或应付卡的提示），当时的紧张分大概从哪里降到哪里？"
      },
      {
        "id": "m10",
        "role": "user",
        "turn": 5,
        "text": "有过的，就是周四去分享会签到那会儿，刚开口前我特意憋气做了两轮呼吸，感觉嗓子没那么紧了。当时紧张分好像是从大概六十分降到了五十左右吧，虽然后面被问到名字时还是有点慌，但至少那几分钟没想跑。"
      },
      {
        "id": "m11",
        "role": "assistant",
        "turn": 6,
        "text": "基于这些经历，你愿意把“触发—第一步应对”再浓缩成一句你对自己的提示语吗？"
      },
      {
        "id": "m12",
        "role": "user",
        "turn": 6,
        "text": "嗯……大概就是“就算被冷场也没关系，她们可能只是在忙”。就是觉得，以前我总是把别人没理我当成全世界都讨厌我，现在试着逼自己把这句话念几遍，好像嗓子没那么紧一点了。虽然还是有点怕，但好像也没那么可怕了。"
      },
      {
        "id": "m13",
        "role": "assistant",
        "turn": 7,
        "text": "如果对比你第一次来咨询的状态和现在，你觉得自己最大的不同是什么？"
      },
      {
        "id": "m14",
        "role": "user",
        "turn": 7,
        "text": "其实……我也觉得有点不一样了。以前一提到要说话，我就觉得喉咙像被堵住了一样，根本不敢开口，总觉得大家肯定不喜欢我这个外人。上回在班会上，虽然我还是挺紧张的，嗓子里也有点紧，但我真的敢跟同学打招呼、聊了几句，那种“我一定被排斥了”的恐惧感好像没那么重了。\n\n不过，要是让我说最大不同，我其实也不太确定。有时候明明做好了准备，话到嘴边又卡住，那种习惯性的退缩还在。但就是……没那么害怕了，至少我觉得自己可能没那么糟糕，也能被接纳一点点。"
      },
      {
        "id": "m15",
        "role": "assistant",
        "turn": 8,
        "text": "我们把视角拉开一些：目前在人际互动、睡眠和注意力这几块，你觉得自己分别处在什么水平？用词语锚点（比如轻度/中度）或自己的大范围区间来描述就好。"
      },
      {
        "id": "m16",
        "role": "user",
        "turn": 8,
        "text": "我觉得现在稍微比之前好一点点，睡眠虽然还是偶尔两点多才睡，但至少最近几晚能自己在十二点半左右睡着了，没那么僵了。上课走神的情况也少了一些，好像能跟着老师讲一会儿了。不过一碰到人际冲突，那种心慌和委屈还是会特别强烈，感觉还没完全停住。"
      },
      {
        "id": "m17",
        "role": "assistant",
        "turn": 9,
        "text": "在你这几周的交流和行动里，有没有一个片段最能代表“你在把改变继续落实”？"
      },
      {
        "id": "m18",
        "role": "user",
        "turn": 9,
        "text": "其实要说最能代表我在改变的，可能就是上周四在班级分享会那次吧。虽然签到时我还是皱了皱鼻子，手心里全是汗，但后来我真的主动跟旁边两个同学说了句“刚才讲得有点快，大家听清楚了吗”，他们居然还笑着回了我。那一瞬间我突然觉得，好像也没那么可怕，毕竟之前总觉得自己是个多余的外人，可今天好像真的能接上话了。"
      },
      {
        "id": "m19",
        "role": "assistant",
        "turn": 10,
        "text": "在这个片段里，你觉得对你帮助最大的一个步骤是哪一个？"
      },
      {
        "id": "m20",
        "role": "user",
        "turn": 10,
        "text": "其实说是“把话说清楚”那个步骤吧，之前我明明觉得委屈，却总是忍着不说，结果心里更堵。上周在分享会前，我特意先做了两次深呼吸，然后把那句“其实想聊两句”轻轻说了出来，虽然最后嗓子还是有点紧，但好像没像以前那样瞬间就想逃。"
      },
      {
        "id": "m21",
        "role": "assistant",
        "turn": 11,
        "text": "如果有一个情绪或念头会比较习惯性地抬高你的紧张/委屈，此刻你会命名它为什么？面对它，你最想对自己说的一句话是什么？"
      },
      {
        "id": "m22",
        "role": "user",
        "turn": 11,
        "text": "有时候那个念头就是觉得“她们肯定都在背后说我，我是个多余的人”，一这样想，我整个人就僵硬得动不了了。面对它，我最想对自己说的是“先别急着下结论，她们可能只是忙吧，我也不是完美的”，但说实话，刚说完这句话心里还是会发慌。"
      },
      {
        "id": "m23",
        "role": "assistant",
        "turn": 12,
        "text": "当那个念头一出现时，你身体里最明显的一个信号是哪一个？此刻你能给自己用到的一个呼吸或体感提示语是什么？"
      },
      {
        "id": "m24",
        "role": "user",
        "turn": 12,
        "text": "其实吧，最明显的信号就是嗓子会突然发紧，有时候连话都说不利索，感觉像堵了一块棉花。我会试着对自己说“没关系，慢慢来”，然后深呼吸两下，但说实话，只要那个念头一冒出来，那股紧张感还是很难一下子压下去。"
      },
      {
        "id": "m25",
        "role": "assistant",
        "turn": 13,
        "text": "你愿意把它记成一句简短的提醒吗？比如“嗓子紧→两轮呼吸→安抚语→先确认或轻量表达”。"
      },
      {
        "id": "m26",
        "role": "user",
        "turn": 13,
        "text": "嗯……这个好像挺对的，嗓子一起紧我就知道要卡壳了。那我试着记成：“紧→呼吸→安抚→确认”。不过有时候我在家自己练还行，一到那种人多的场合，可能还是得靠您提醒我一下，不然我又忘了先做这一步。"
      },
      {
        "id": "m27",
        "role": "assistant",
        "turn": 14,
        "text": "在人多的场合，你觉得当时最小而可承受的一小步是什么？"
      },
      {
        "id": "m28",
        "role": "user",
        "turn": 14,
        "text": "其实就是……在大家说话的时候，我哪怕只敢看着老师或者身边同学的侧脸，心里默念一句“我可以坐在这里”，大概是五秒钟吧。再多一点，比如举手或者大声说话，我就真的会全身紧绷，嗓子也发紧，怕到时候说不出话来更尴尬。不过这次分享会我确实做到了坐下听完了，只是全程都在偷偷看自己的手心，不知道做得算不算数。"
      },
      {
        "id": "m29",
        "role": "assistant",
        "turn": 15,
        "text": "我们来做一个小对比：在某一次坐下听讲或轻量交流的片段里，你当时紧张大概在哪个区间？做完你的“小脚本”后，大概又到了哪里？"
      },
      {
        "id": "m30",
        "role": "user",
        "turn": 15,
        "text": "那次在班级分享会签到的时候，刚开始挺紧张的，估计有六成吧，手心里全是汗，不敢抬头。不过说完“大家好”之后，听别人回应了几句，我就稍微放松些了，下来大概还有四成，感觉没那么僵硬了，至少没僵住。"
      },
      {
        "id": "m31",
        "role": "assistant",
        "turn": 16,
        "text": "如果用词语来标一下你此刻的状态，是偏轻、中等，还是偏强的紧张/委屈？你觉得哪个迹象最能让你感觉到“我今天确实比昨天更有进展一点”？"
      },
      {
        "id": "m32",
        "role": "user",
        "turn": 16,
        "text": "这次比上次稍微轻松一点吧，紧张大概是中等偏轻，委屈没那么重了，可能是因为我上周真的试着跟同学聊了几句，虽然刚开始嗓子还是有点紧，但最后没退缩。我觉得最有进展的是那天在图书馆，明明心里打鼓，但还是跟那位同学说了五十分钟，结束后那种“我也可以”的感觉特别真实，连自己都没意识到嘴角是上扬的。"
      },
      {
        "id": "m33",
        "role": "assistant",
        "turn": 17,
        "text": "为了后续做预防准备，我们先做一个最小版本的触发清单：最近三天，你觉得最可能让紧张升起来的场景有哪几类？"
      },
      {
        "id": "m34",
        "role": "user",
        "turn": 17,
        "text": "最近三天嘛，应该就是晚上回宿舍准备睡觉那会儿吧，总觉得她们还在说话，心里特别烦躁，嗓子也紧。还有就是早上上课前，想到要面对小组里的几个人，我就忍不住想逃，怕又冷场或者被排挤。"
      },
      {
        "id": "m35",
        "role": "assistant",
        "turn": 18,
        "text": "在“睡前烦躁”和“小组场景”里，你最常出现的早期信号分别是什么？"
      },
      {
        "id": "m36",
        "role": "user",
        "turn": 18,
        "text": "其实每次躺下想睡的时候，心里头就会莫名地特别慌，总觉得是不是又做错了什么，或者明天肯定会被她们嫌弃，然后就不敢闭眼，只能在那儿数羊或者胡思乱想；至于小组里嘛，可能就是一遇到稍微有点争执，我就特别怕他们觉得我烦，就把话咽回去，结果心里更堵得慌，不知道该怎么说。"
      },
      {
        "id": "m37",
        "role": "assistant",
        "turn": 19,
        "text": "把此刻放在紧张/委屈的强度上，更接近轻度、中等，还是偏强？"
      },
      {
        "id": "m38",
        "role": "user",
        "turn": 19,
        "text": "我觉得吧，好像不是特别强，但也远不到轻轻飘飘那种程度。刚才做分享会的时候，心里那个“怕被讨厌”的疙瘩还是有点硬，嗓子眼儿有点发紧，但好在没像以前那样直接堵死。"
      },
      {
        "id": "m39",
        "role": "assistant",
        "turn": 20,
        "text": "从这一周的安排看，你觉得哪个最可能触发紧张的微场景最适合写进你的蓝图？"
      },
      {
        "id": "m40",
        "role": "user",
        "turn": 20,
        "text": "我觉得上次那个班级分享会虽然做下来了，但心里还是觉得有点虚。就是那种突然要开口说话，怕别人冷场，或者怕说完大家就又不理我的那种感觉。每次这种时候，我就忍不住想，万一我又说错话了怎么办？"
      },
      {
        "id": "m41",
        "role": "assistant",
        "turn": 21,
        "text": "我们把这些状态条目化：当紧张升高时，“被冷场”和“怕说错”分别处于什么强度（比如轻度/中等/偏强或0–100）？身体上最明显的列出来，你也会知道触发阈值会落在什么范围。"
      },
      {
        "id": "m42",
        "role": "user",
        "turn": 21,
        "text": "嗯……上次在分享会刚坐下那会儿，心里大概就有七八十分了，身体就是手心特别凉，然后喉咙像堵住了一样，差点说不出话。怕说错的时候大概也有六七分吧，最明显还是心脏狂跳，感觉耳边嗡嗡响。是不是我这种反应算太明显了？有时候我也觉得自己是不是太敏感了，怕你们觉得我太矫情。"
      },
      {
        "id": "m43",
        "role": "assistant",
        "turn": 22,
        "text": "你很在意别人对你是否敏感的看法，这种担心很正常，也被我们以前练习里其他来访者提到过。当触发出现时，最先冒出来的一句念头是什么？"
      },
      {
        "id": "m44",
        "role": "user",
        "turn": 22,
        "text": "其实……上次去兴趣社报名前，我就一直担心“她们肯定觉得我很奇怪，想退出来”。当时脑子里就冒出那句“多我一个外人，多尴尬”，然后我就把手机锁屏了，最后根本没敢发那个申请。是不是每次快开口的时候，那个“别人会怎么看我”的念头就先堵住了我？"
      },
      {
        "id": "m45",
        "role": "assistant",
        "turn": 23,
        "text": "在“被堵塞”的那一刻，你愿意先尝试的最小动作是什么？"
      },
      {
        "id": "m46",
        "role": "user",
        "turn": 23,
        "text": "其实我也忍不住想过，是不是就直接说“我会很尴尬”或者“不想说”，这样至少不用面对她们异样的眼神。但刚才在分享会里，哪怕只是递张纸巾，我心里那股想逃的劲儿还是上来了，最后好像还是硬着头皮说了句谢谢。"
      },
      {
        "id": "m47",
        "role": "assistant",
        "turn": 24,
        "text": "那片刻的缓解对你很重要。如果在这些体验里选一个更可持续、也让你舒服的小动作，你会选哪一个？"
      }
    ],
    "preview_message_ids": [
      "m01",
      "m02",
      "m03",
      "m04",
      "m05",
      "m06"
    ]
  },
  "memoryAfter": {
    "available": false,
    "reason": "此导出记录不包含本场结束后由记忆模块写回的状态，未补造。"
  },
  "expectedEnding": {
    "messages": [
      {
        "id": "expected-1",
        "role": "user",
        "text": "我想先选一个不那么难的：下次分享会，先坐下来听，结束后如果愿意，就跟旁边的人说一句谢谢。不要求自己一定聊很久。",
        "source_kind": "authored_expected_demo"
      },
      {
        "id": "expected-2",
        "role": "assistant",
        "text": "可以。你希望练习的是给自己一点选择，而不是逼自己表现好。今天我们从“不敢开口”谈到了你已经尝试过的连接，也看到紧张还会回来。呼吸、看卡片可以作为提醒，不必等紧张完全消失。关于这次的小尝试，你还有什么想调整的吗？",
        "source_kind": "authored_expected_demo"
      },
      {
        "id": "expected-3",
        "role": "user",
        "text": "就这样吧。我觉得少一点反而做得到。睡觉的事还有点困扰，不过今天不想再展开了。",
        "source_kind": "authored_expected_demo"
      },
      {
        "id": "expected-4",
        "role": "assistant",
        "text": "好，睡眠这部分我们留着，下次先听听你的近况。今天先保留你选的这一个小尝试，愿意的话记下当时发生了什么、自己有什么感受，不要求打分。你觉得我们今天可以在这里收一收了吗，还是还有一句重要的话想说？",
        "source_kind": "authored_expected_demo"
      },
      {
        "id": "expected-5",
        "role": "user",
        "text": "可以结束了。今天带走的就是，不用一下变得很会聊天，也可以慢慢试。",
        "source_kind": "authored_expected_demo"
      },
      {
        "id": "expected-6",
        "role": "assistant",
        "text": "是的，可以慢慢试，也可以根据自己的感受调整。下次我们先看看这次尝试和睡眠的情况，再一起决定接下来谈什么。谢谢你今天把这些不容易的感受告诉我，我们今天就到这里。",
        "source_kind": "authored_expected_demo"
      }
    ],
    "memory": {
      "source_kind": "authored_expected_demo",
      "persisted": false,
      "session_number": 8,
      "session_summary": "讨论人际互动中的紧张与回避，回顾呼吸及应付卡的使用；来访者选择低负担的小尝试，并同意结束本次会谈。",
      "agreed_action": "下次分享会先坐下听；若愿意，结束后向旁边的人说一句谢谢。不要求交流时长或打分。",
      "client_takeaway": "不用一下变得很会聊天，也可以慢慢试。",
      "unresolved": [
        "睡眠困扰仍需跟进，来访者本次不希望展开。",
        "对冷场和他人评价的担忧仍存在，不宣称已解决。"
      ],
      "next_session_focus": [
        "先询问近况及小尝试的实际体验。",
        "征询是否继续讨论睡眠，再协商本次议程。"
      ],
      "uncertainty": "原始rollout中的交流时长表述不一致，未将时长写成确定进展；不根据旧历史推断当前风险结论。"
    }
  }
};
